module.exports = __webpack_public_path__ + "static/media/e-finance.09d63a4b.png";